import { Component, OnInit, Input } from '@angular/core';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ActivatedRoute } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-released-resources',
  templateUrl: './released-resources.component.html',
  styleUrls: ['./released-resources.component.scss']
})

export class ReleasedResourcesComponent implements OnInit {
  empRole = '';
  objectId: '';
  userIdArr = [];
  totalReleasedResources: number;
  releasedResources = [];
  @Input() projectId: any;
  isEdit: boolean;
  cols: any[];
  projectTypeOptions: SelectItem[];
  rollOptions: SelectItem[];
  roleDD = [];
  rollOptions1: any[];

  constructor(
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private dateConvertor: DateConvertor,
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration,

  ) {
    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'Name', field: 'username' },
      { header: 'Email', field: 'email' },
      { header: 'Designation', field: 'designation' },
      // { header: 'Start Date', field: 'startDate' },
      // { header: 'End Date', field: 'endDate' },
      // { header: 'Resource Type', field: 'resourceType' },
      { header: 'Status', field: 'status' },

    ];
    this.projectTypeOptions = [
      { label: 'Add on', value: 'Add on' },
      { label: 'Dedicated', value: 'Dedicated' },
      { label: 'Fixed', value: 'Fixed' }
    ];
  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.isEdit = false;
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
      }
    });
    this.getReleasedResources();
    this.getRollOption();
  }

  /*
  ** ==========================================================
  ** Get role
  ** ==========================================================
  */
  getRollOption() {
    let result = [];
    let resultDD = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        result.push({ name: roleList.name, id: roleList.objectId });
        resultDD.push(roleList.name);
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
      this.rollOptions1 = this.bindRoleDropDown(resultDD);

    });
  }

  /*
  ** ==========================================================
  ** Bind drop down values
  ** ==========================================================
  */
  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.name });
    });
    return dropDownItem;
  }

  bindRoleDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a, value: a });
    });
    return dropDownItem;
  }

  /*
  ** ==========================================================
  ** Get released resources
  ** ==========================================================
  */
  async getReleasedResources() {
    let id = '';
    if (this.empRole == 'Admin') {
      id = this.objectId;
    } else if (this.empRole != 'Admin') {
      id = this.projectId;
    }
    this.totalReleasedResources = await this.getCount('Released');
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      {
        condition: 'equalTo', field: 'project',
        value: {
          __type: 'Pointer',
          className: 'Project',
          objectId: id
        }
      },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Released' },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'user.profile' },
      // { condition: 'include', value: 'profile.role' },
      { condition: 'limit', value: 1000 }
    ]).then(results => {
      this.releasedResources = this.loadValue(results, 0);
    });
  }

  /*
  ** ==========================================================
  ** Released resource details
  ** ==========================================================
  */
  loadValue(results, skip) {
    let i = skip;
    let result = [];
    results.forEach((element, index) => {
      i = i + 1;
      let userObject = element.get('user');
      let profile = userObject.get('profile')
      this.userIdArr.push(element);
      let roleObj = profile.get('role');
      let emailObj = profile.get('officialInfo');
      let jsonText = JSON.stringify(element);
      let userRole = JSON.parse(jsonText);
      result.push({
        objectId: userRole.objectId,
        position: i,
        username: profile.get('firstName') + ' ' + profile.get('lastName'),
        // startDate: this.dateConvertor.momentChange(userRole.startDate.iso),
        // endDate: this.dateConvertor.momentChange(userRole.endDate.iso),
        resourceType: userRole.resourcesType,
        status: userRole.status,
        email: emailObj.officialEmail,
        designation: roleObj.get('name'),
        action: ''
      });
    });
    return result;
  }

  /*
  ** ==========================================================
  ** Get released resource count
  ** ==========================================================
  */
  getCount(type) {
    let id = '';
    if (this.empRole == 'Admin') {
      id = this.objectId;
    } else if (this.empRole != 'Admin') {
      id = this.projectId;
    }
    return this.queryInterface.getQueryCount(this.parseService, 'ProjectMembers', [
      {
        condition: 'equalTo', field: 'project',
        value: {
          __type: 'Pointer',
          className: 'Project',
          objectId: id
        }
      },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: type },
      { condition: 'include', value: 'profile' },
      { condition: 'include', value: 'profile.role' }
    ]);
  }


}
